
import React from "react";
import {
  LayoutDashboard,
  Users,
  CreditCard,
  ChartNoAxesColumn,
  Database,
  Settings,
  LogOut,
  ChevronDown,
  Heart,
  X,
  UserCog,
  ShieldCheck,
} from "lucide-react";

const mainMenu = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    label: "Members",
    path: "/members",
    icon: Users,
  },
  {
    label: "Membership Plans",
    path: "/membership-plans",
    icon: CreditCard,
  },
  {
    label: "Payments",
    path: "/payments",
    icon: CreditCard,
  },
  {
    label: "Reports",
    path: "/reports",
    icon: ChartNoAxesColumn,
  },
];

const managementMenu = [
  {
    label: "Staffs",
    path: "/staffs",
    icon: UserCog,
  },
  {
    label: "Assign Roles",
    path: "/assign-roles",
    icon: ShieldCheck,
  },
  {
    label: "Masters",
    path: "/masters",
    icon: Database,
  },
  {
    label: "Settings",
    path: "/settings",
    icon: Settings,
  },
];

function BrandLogo() {
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex h-10 w-10 items-center justify-center text-blue-700">
        <Heart size={32} strokeWidth={1.8} />
        <Heart
          size={13}
          fill="currentColor"
          className="absolute text-pink-500"
        />
      </div>

      <div>
        <h2 className="whitespace-nowrap text-sm font-bold text-blue-800">
          சேலம் <span className="text-pink-600">கொங்கு</span>
        </h2>
        <p className="text-center text-[8px] text-gray-500">
          திருமண தகவல் மையம்
        </p>
      </div>
    </div>
  );
}

function Sidebar({
  activePath,
  onNavigate,
  mobileOpen,
  onClose,
}) {
  const renderMenu = (items) =>
    items.map(({ label, path, icon: Icon }) => {
      const isActive =
        activePath === path ||
        (path !== "/dashboard" &&
          activePath.startsWith(`${path}/`));

      return (
        <button
          type="button"
          key={path}
          onClick={() => {
            onNavigate(path);
            onClose();
          }}
          className={`mb-1 flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-xs transition ${
            isActive
              ? "bg-blue-50 font-semibold text-blue-600"
              : "text-slate-600 hover:bg-slate-50"
          }`}
        >
          <Icon size={17} />
          <span>{label}</span>
        </button>
      );
    });

  return (
    <>
      {mobileOpen && (
        <button
          type="button"
          aria-label="Close sidebar overlay"
          onClick={onClose}
          className="fixed inset-0 z-40 bg-slate-900/40 lg:hidden"
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-[232px] flex-col border-r border-slate-200 bg-white transition-transform duration-200 ${
          mobileOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="flex h-[75px] items-center justify-between border-b border-slate-200 px-4">
          <BrandLogo />

          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 lg:hidden"
            aria-label="Close menu"
          >
            <X size={18} />
          </button>
        </div>

        <div className="mx-2 mt-4 flex items-center gap-2 rounded-xl border border-blue-100 bg-blue-50/70 p-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-100 text-blue-600">
            <Database size={17} />
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-[9px] text-slate-500">
              Logged in as
            </p>
            <p className="truncate text-[10px] font-semibold text-slate-800">
              Super Administrator
            </p>
          </div>

          <ChevronDown size={14} className="text-slate-500" />
        </div>

        <div className="mt-7 px-4 pb-2 text-[9px] font-semibold tracking-wider text-slate-400">
          MAIN MENU
        </div>

        <nav className="px-2">
          {renderMenu(mainMenu)}
        </nav>

        <div className="mt-5 px-4 pb-2 text-[9px] font-semibold tracking-wider text-slate-400">
          MANAGEMENT
        </div>

        <nav className="px-2">
          {renderMenu(managementMenu)}
        </nav>

        <div className="mt-auto border-t border-slate-100 p-2">
          <button
            type="button"
            onClick={() =>
              alert("Logout confirmation UI will be added later.")
            }
            className="flex w-full items-center gap-3 rounded-lg bg-rose-50 px-3 py-3 text-xs text-rose-600 hover:bg-rose-100"
          >
            <LogOut size={17} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;